import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { faqs } from "./components/FAQ";
import Navbar from "@/components/feature/Navbar";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";
import Avis from "@/components/feature/Avis";
import Hero from "./components/Hero";
import Reassurances from "./components/Reassurances";
import LamesCassees from "./components/LamesCassees";
import RemplacementTablier from "./components/RemplacementTablier";
import Calibrage from "./components/Calibrage";
import ReparerPlutot from "./components/ReparerPlutot";
import CTAAppel from "./components/CTAAppel";
import FAQ from "./components/FAQ";
import Galerie from "./components/Galerie";
import Maillage from "./components/Maillage";
import Formulaire from "./components/Formulaire";

export default function TablierVoletRoulantPage() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Tablier Volet Roulant Strasbourg | Remplacement Lames"
        description="Remplacement de tablier et de lames de volet roulant à Strasbourg et dans le Bas-Rhin. PVC et aluminium, devis gratuit. 03 74 47 32 40."
        path="/tablier-volet-roulant"
        type="service"
        serviceType="Remplacement de tablier de volet roulant"
        faqs={faqs}
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Tablier volet roulant" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Tablier volet roulant" }]} />
      <main>
        <Hero />
        <DiagnosticVideo />
        <Reassurances />
        <LamesCassees />
        <RemplacementTablier />
        <Calibrage />
        <ReparerPlutot />
        <CTAAppel />
        <FAQ />
        <Galerie />
        <Maillage />
        <Formulaire />
        <CTAAppel />
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}